import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SubscriptionSettingsService } from './subscription-settings.service';

/**
 * Keeps the whole Subscription section behind the business's own settings.
 *
 * The side menu already drops the section when subscriptions are switched off,
 * but a menu is a signpost, not a lock: a typed URL, a bookmark or the
 * browser's history would still walk straight in. The rule is the server's —
 * `chargeSubscriptionPp` refuses on the same two columns — so it is stated
 * where it cannot be walked around.
 *
 * Reads the settings already on `doctorSettings$` from the profile bootstrap;
 * nothing is fetched. Until those land it lets the navigation through, because
 * bouncing a business off its own section on a slow load is worse than showing
 * it a moment early.
 */
export const subscriptionsEnabledGuard: CanActivateFn = () => {
  const settings = inject(SubscriptionSettingsService);
  const router = inject(Router);

  return settings.enabled ? true : router.createUrlTree(['/app/dashboard']);
};
